import { Component } from "@angular/core";

@Component({
  selector: 'panel-content',
  template: `<ng-content>panel-content</ng-content>`,
})
export class PanelContentComponent {}